module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/feature01-5607072d751d25305bc989fc43fac5ac.svg";